import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSidebarStore = defineStore('sidebar', () => {
  const expanded = ref(false)

  const toggle = () => {
    expanded.value = !expanded.value
  }

  const expand = () => {
    expanded.value = true
  }

  const collapse = () => {
    expanded.value = false
  }

  return {
    expanded,
    toggle,
    expand,
    collapse,
  }
}, {
  persist: {
    key: 'ecx-corp-sidebar',
    storage: localStorage,
  },
})
